<script setup lang="ts">
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { IActionType } from "@/components/Common/Dropdown/CActionsDropdown.types";

interface Props {
  list: IActionType[];
  selectedItem?: unknown;
  disabled?: boolean;
}
defineProps<Props>();

const emit = defineEmits(["edit", "delete"]);
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger class="ml-auto flex">
      <button
        class="h-7 w-7 ml-auto nr-5 flex items-center justify-center gap-2.5 rounded-md bg-gray-100 group hover:bg-green-100 focus:bg-green-100 cursor-pointer transition-300"
      >
        <i
          class="icon icon-more text-xl leading-5 text-dark-100 group-hover:text-green transition-300"
        ></i>
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-40" side="left">
      <DropdownMenuGroup>
        <DropdownMenuItem
          v-for="(item, index) in list"
          :key="index"
          :disabled="item.value === 'deleteExchange' && disabled"
          @click.stop="
            item.value === 'edit'
              ? emit('edit', selectedItem)
              : emit('delete', selectedItem)
          "
        >
          <span> {{ $t(item.label) }}</span>
          <DropdownMenuShortcut>
            <i :class="item.icon" class="text-gray text-xl transition-300" />
          </DropdownMenuShortcut>
        </DropdownMenuItem>
      </DropdownMenuGroup>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
